require('!!raw-loader!/builds/877459/v2/src/index.html');